import { UserWorkoutSession } from '../workoutsession/userworkoutsession';
import { GymState } from './gymstate';
import { IGymSchedule } from './igymschedule';

export class InMemoryGymSchedule implements IGymSchedule {
  public lastKeepaliveTime: Date;
  public readonly sessions: UserWorkoutSession[] = [];
  public size: number;
  public sessionsAtTimeSlots: Map<number, GymState>;

  private readonly amountOfStationsAtGym: number;
  public amountOfStations(): number {
    return this.amountOfStationsAtGym;
  }

  public setState(cycleTime: number, state: GymState): Promise<void> {
    return new Promise((resolve) => {
      this.sessionsAtTimeSlots.set(cycleTime, state);
      resolve();
    });
  }

  public getState(cycleTime: number): Promise<GymState | undefined> {
    return new Promise((resolve, reject) => {
      const state = this.sessionsAtTimeSlots.get(cycleTime);
      resolve(state);
    });
  }

  public hasState(cycleTime: number): Promise<boolean> {
    return new Promise((resolve) => {
      const hasKey = this.sessionsAtTimeSlots.has(cycleTime);
      resolve(hasKey);
    });
  }

  public getAll(): Promise<Map<number, GymState>> {
    return new Promise((resolve) => {
      resolve(this.sessionsAtTimeSlots);
    });
  }
}
